<template>
    <div>
        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'信息获取详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                                    <h1>需求信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail36">
                                        <el-form :model="f" label-position="right"
                                                 ref="f" :inline="true" class="demo-ruleForm h-formbLine">
                                            <el-form-item label="拜访时间" class="h-elformWrap-2" v-if="f.userCare">
                                                <el-date-picker type="date"
                                                                v-model="f.userCare.cdate"
                                                                :v="f.userCare.cdate" readonly></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                                <el-input v-model="f.euType" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="客户名称" class="h-elformWrap-2" prop="formCon5">
                                                <el-input v-model="f.euName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode" v-if="customer.areaCode">
                                                <el-input v-model="customer.areaCode" :v="customer.areaCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode" v-if="customer.channelCode">
                                                <el-input v-model="customer.channelCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="部门科室" class="h-elformWrap-2" prop="department">
                                                <el-input v-model="f.department" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" prop="formCon4">
                                                <el-input v-model="f.contactuserName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系方式" class="h-elformWrap-2" prop="formCon6">
                                                <el-input v-model="f.telephone" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求分类" class="h-elformWrap-2">
                                                <el-input value="信息获取" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="预计投标日期" class="h-elformWrap-2" prop="bidConvDate" v-if="f.bidConvDate">
                                                <el-date-picker type="date" value-format="yyyy-MM-dd"
                                                                v-model="f.bidConvDate" :picker-options="pickerOptions" readonly></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="预计成单日期" class="h-elformWrap-2" prop="expConvDate" v-if="f.expConvDate">
                                                <el-date-picker type="date" value-format="yyyy-MM-dd"
                                                                v-model="f.expConvDate" :picker-options="pickerOptions" readonly></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="中标概率" class="h-elformWrap-2" prop="bidPercentage" v-if="f.bidPercentage">
                                                <el-input v-model="f.bidPercentage" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="拜访目的" class="h-elformWrap-2" prop="formCon10" v-if="f.userCare">
                                                <el-input v-model="f.userCare.planRemark"
                                                          :v="f.userCare.planRemark" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="拜访结果" class="h-elformWrap-2" prop="formCon11"
                                                          v-if="f.userCare">
											  <div style="width: 100%;border-bottom: 1px solid #dedede;color: #868686;word-break:break-all;padding-left: 0.15rem;">{{f.userCare.result}}</div>
                                                <!-- <el-input v-model="f.userCare.result" :v="f.userCare.result" readonly></el-input> -->
                                            </el-form-item>
                                            <el-form-item label="用户在用产品" class="h-elformWrap-1"
                                                          style="margin-bottom:0.2rem" v-if="f.productInfoList.length!=0">
                                                <div class="categoryBox">
                                                    <div class="category" :class="{'active':item==categorys}"
                                                         @click="selectC(item)" v-for="(item,index) in category"
                                                         :key="index">{{item}}
                                                    </div>
                                                </div>
                                                 <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                                                     <el-table
                                                             ref="multipleTable"
                                                             :data="productList"
                                                             style="width: 100%"
                                                             :border="true"
                                                     >
                                                         <el-table-column
                                                                 type="index"
                                                                 width="40"
                                                                 label="#">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="category"
                                                                 label="产品大类"
                                                                 width="170" >
                                                             <template scope="scope">
                                                                 <el-select v-model="scope.row.category" :disabled="true">
                                                                     <el-option v-for="(item) in LevelName"
                                                                                :key="item.id"
                                                                                :label="item.levelname"
                                                                                :value="item.id">
                                                                     </el-option>
                                                                 </el-select>
                                                             </template>
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="specification"
                                                                 label="产品型号"
                                                                 width="180">
                                                             <template scope="scope">
                                                                 <el-select v-model="scope.row.specification"
                                                                            placeholder="请选择" :disabled="true">
                                                                     <el-option v-for="(item) in ProModel"
                                                                                :key="item.id"
                                                                                :label="item.levelname"
                                                                                :value="item.id">
                                                                     </el-option>
                                                                 </el-select>
                                                             </template>
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="amount"
                                                                 label="产品数量"
                                                                 width="80">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="barCode"
                                                                 label="条形码"
                                                                 width="150">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="isOverdue"
                                                                 label="是否超限期使用"
                                                                 width="150">
                                                             <template scope="scope">
                                                                 <brselect category="isOverdue" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                                                           :disabled="true"></brselect>
                                                             </template>
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="exfactoryDate"
                                                                 label="出厂日期"
                                                                 width="150">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="purchaseDate"
                                                                 label="购买日期"
                                                                 width="150">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="remark"
																 :show-overflow-tooltip="true"
                                                                 label="备注">
                                                         </el-table-column>
                                                     </el-table>
                                                 </div>
                                                 <div v-if="categorys == '竞品'" style="margin-top:20px;">
                                                     <el-table
                                                             ref="multipleTable"
                                                             :data="jingpinList"
                                                             style="width: 100%"
                                                             :border="true"
                                                     >
                                                         <el-table-column
                                                                 type="index"
                                                                 width="40"
                                                                 label="#">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="category"
                                                                 label="产品大类"
                                                                 width="170">
                                                             <template scope="scope">
                                                                 <el-select v-model="scope.row.category"
                                                                            placeholder="请选择"
                                                                            @change="selectproModel(scope.row.category)" :disabled="true">
                                                                     <el-option v-for="(item) in LevelName"
                                                                                :key="item.id"
                                                                                :label="item.levelname"
                                                                                :value="item.id">
                                                                     </el-option>
                                                                 </el-select>
                                                             </template>
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="specification"
                                                                 label="产品型号"
                                                                 width="180" >
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="amount"
                                                                 label="产品数量"
                                                                 width="80">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="barCode"
                                                                 label="条形码"
                                                                 width="150">
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="isOverdue"
                                                                 label="是否超限期使用"
                                                                 width="150">
                                                             <template scope="scope">
                                                                 <brselect category="isOverdue" :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                                                           :disabled="true"></brselect>
                                                             </template>
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="exfactoryDate"
                                                                 label="出厂日期"
                                                                 width="150" >
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="purchaseDate"
                                                                 label="购买日期"
                                                                 width="150" >
                                                         </el-table-column>
                                                         <el-table-column
                                                                 prop="remark"
																 :show-overflow-tooltip="true"
                                                                 label="备注">
                                                         </el-table-column>
                                                     </el-table>
                                                 </div>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                                    <h1>产品信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail36">
                                        <el-form :model="f" label-position="right"
                                                 ref="f" :inline="true" class="demo-ruleForm h-formbLine">
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="proCode">
                                                <el-input v-model="f.detail.codeName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="proModel">
                                                <el-input v-model="f.detail.proName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="数量(台)" class="h-elformWrap-2" prop="proNumber">
                                                <el-input v-model.number="f.detail.proNumber" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label=产品单价 class="h-elformWrap-2" prop="proPrice">
                                                <el-input v-model.number="f.detail.proPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label=产品总额 class="h-elformWrap-2" prop="proTotalAmount">
                                                <el-input v-model="f.detail.proTotalAmount" readonly></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                            <div class="h-pieceIn2" v-if="f.proMain">
                                <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                                    <h1>项目信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail36">
                                        <el-form :model="f" label-position="right"
                                                 ref="f" :inline="true" class="demo-ruleForm h-formbLine">
                                            <el-form-item label="项目名称" class="h-elformWrap-2" prop="projectName">
                                                <el-input v-model="f.proMain.projectName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="项目状态" class="h-elformWrap-2" prop="isSuccess">
                                                <el-input v-model="f.proMain.isSuccess" readonly></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="backL">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {

                day1: "",
                day2: "",
                LevelName: [],
                ProModel: [],
                showS: true,
                showD: false,
                cg: null,
                category: ['海尔产品', '竞品'],
                productList: [],
                jingpinList: [],
                categorys: '海尔产品',
                tableList: [],
                tableDate: [],
                p1:null,
                p2:null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                customer: {
                    areaCode: null,
                    channelCode: null,
                },
                //带线表单
                f: {
                    productInfoList:[],
                    id: '',
                    date1: '',
                    date2: '',
                    euName: '',
                    demandType: '',
                    userCode: '',
                    content: '',
                    euCode: '',
                    euType:null,
                    bidConvDate: '',
                    expConvDate: '',
                    bidPercentage: '',
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    userCare: {
                        result: null,
                        cdate: null,
                        planRemark: null
                    },
                    detail: {
                        codeName:'',
                        proCode: '',
                        proModel: '',
                        proName:'',
                        proNumber: '',
                        proPrice:'',
                        proTotalAmount:'',
                    },
                    proMain:{
                        isSuccess:null,
                        projectName:'',
                    },
                },
            }
        },
        methods: {
            selectC(item) {
                this.categorys = item;
            },
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            showproModel(value) {
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            selectproModel(value) {
                this.f.detail.proModel='';
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            query() {
                this.f.id = this.$route.query.id;
                ss.UserDemand.demandDetail2(this.f.id).then(rd => {
                    this.f = rd;
                    this.showproModel(rd.detail.proCode);
                    this.f.euType = this.$getDictName("userCareType", rd.euType);
                    this.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                    this.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                    this.f.demandType = this.$getDictName("xuqiu_type",rd.demandType);
                    this.f.bidPercentage = this.f.bidPercentage+'%';
                    for (var i = 0; i < rd.productInfoList.length; i++) {
                        if (rd.productInfoList[i].type == "1") {
                            this.productList.push(rd.productInfoList[i]);
                        } else if (rd.productInfoList[i].type == "2") {
                            this.jingpinList.push(rd.productInfoList[i]);
                        }
                    }
                    if(this.f.proMain){
                        this.f.proMain.isSuccess = this.$getDictName("pro_success",rd.proMain.isSuccess);
                    }
                })
            },
            delPlan(index) {
                if (this.categorys == '海尔产品') {
                    this.productList.splice(index, 1);
                } else if (this.categorys == '竞品') {
                    this.jingpinList.splice(index, 1);
                }
            },
            backL() {
                this.$router.go(-1);
            },
        },
        created() {
            this.query();
            this.showLevelName();
        }
    }
</script>

<style scoped>
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .categoryBox .category {
        width: 122px;
        height: 36px;
        color: #b0b0b0;
        font-size: 0.2rem;
        text-align: center;
        line-height: 36px;
        margin-left: 20px;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #0e75e9;
        background: #0e75e9;
    }
    .weekplandetail36 {
        margin-top: 0.38rem
    }
</style>
<style>

    .weekplandetail36 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .weekplandetail36 .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .weekplandetail36 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail36 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail36 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
        margin-bottom: 20px;
    }

    .weekplandetail36 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }
</style>
